import styled from "styled-components";
import { BodyValue, InfoItem, InfoName, InfoValue, InfoValueText } from "../../../../../components/info-block/styles";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
`
export const TopInfoWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-top:20px;

  @media screen and (max-width: 768px) {
    & > div {
      width: 100% !important;
      min-width: 0;
      max-width: 100%;
    }

    ${InfoItem} {
      flex-direction: column;
      align-items: flex-start;
      gap: 2px;
      min-width: 0;
    }

    ${InfoName},
    ${BodyValue} {
      width: 100%;
      min-width: 0;
    }

    ${InfoValue},
    ${InfoValueText} {
      max-width: 100%;
      white-space: normal;
      overflow-wrap: anywhere;
      word-break: break-all;
    }
  }
`
